import * as React from "react"
const CheckIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.286 1A2.288 2.288 0 0 0 1 3.286v11.428A2.288 2.288 0 0 0 3.286 17h11.428A2.288 2.288 0 0 0 17 14.714V3.286A2.288 2.288 0 0 0 14.714 1H3.286Zm9.75 6.321-4.572 4.572a.854.854 0 0 1-1.21 0L4.968 9.607a.857.857 0 0 1 1.21-1.21l1.68 1.678 3.963-3.968a.857.857 0 0 1 1.21 1.21l.005.004Z"
    />
  </svg>
)
export default CheckIcon
